import { forwardRef } from "react";

import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export type InfoIconProps = IconClientSVGProps & {
  filled?: boolean;
};

export const InfoIcon = forwardRef<SVGSVGElement, InfoIconProps>(
  ({ label, filled = false, ...props }, ref) => {
    return (
      <Icon label={label}>
        {filled ? (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            {...props}
            ref={ref}
          >
            <path
              d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
              fill="#0F0F14"
              stroke="#0F0F14"
              strokeLinecap="square"
            />
            <path
              d="M8 5.5V5.6M8 7.5V10.5"
              stroke="#FAFAFF"
              strokeLinecap="square"
            />
          </svg>
        ) : (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            {...props}
            ref={ref}
          >
            <path
              d="M8 6V6.1M8 8V11M14 8.5C14 11.8137 11.3137 14.5 8 14.5C4.68629 14.5 2 11.8137 2 8.5C2 5.18629 4.68629 2.5 8 2.5C11.3137 2.5 14 5.18629 14 8.5Z"
              stroke="currentcolor"
              strokeLinecap="square"
            />
          </svg>
        )}
      </Icon>
    );
  },
);

InfoIcon.displayName = "InfoIcon";
